import React from 'react';
import {
    Box,
    CircularProgress,
    Container,
} from '@mui/material';

export default function AuthLoadingContainer() {
    return (
        <Box>
            <Container>
                <CircularProgress />
            </Container>
        </Box>
    );
}
